<template>
  <div id="faq">
    <v-layout wrap class="flex-align-end">
      <v-flex sm4 class="pr-2">
        <v-select
          width="100"
          class="filter_left pt-0"
          v-model="filterStatus" 
          label="Filter by PDF status"
          :items="statusListAll"
          @change="filterByStatus"
          >
        </v-select>
      </v-flex>
      <v-flex sm4 class="pr-2">
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search here"
          class="pt-0"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-data-table
      :headers="headers"
      :items="localDocumentList"
      :search="search"
      class="pf-data-table" 
      :pagination.sync="pagination"
      :expand="expandTable"
    >
        <template v-slot:items="props">
            <tr @click="props.expanded = !props.expanded" class="cursor-pointer">
                <td>{{ props.item.account.name }}</td>
                <td>{{ props.item.account.nickname }}</td>
                <td class="pf-text-blue" @click.stop="logonFamily(props.item.account)">{{ props.item.account.ppn }}</td>
                <td v-if="Agency.is_super_admin || Agency.is_super_writer" width="180" @click.stop="{}">
                  <v-select
                    :disabled="getDocumentStatusText(props.item) === 'Completed'"
                    v-model="props.item.writer"
                    :item-text="'name'"
                    :item-value="'id'"
                    :items="writersList"
                    @change="updateProfileDocument(props.item, 'manual', props.index)"></v-select>
                </td>
                <td v-if="Agency.is_super_admin || Agency.is_super_writer" width="180" @click.stop="{}">
                  <v-select
                    :disabled="getDocumentStatusText(props.item) !== 'Completed'"
                    v-model="props.item.designer"
                    :item-text="'name'"
                    :item-value="'id'"
                    :items="designersList"
                    @change="updateProfileDocument(props.item, 'manual', props.index)"></v-select>
                </td>
                <!-- <td>{{ props.item.chapters && props.item.chapters.length ? props.item.chapters.length : 0 }}</td> -->
                <td>{{ props.item.submitted_date ? formatDateString(props.item.submitted_date, 'MM/DD/YYYY') : '--' }}</td>
                <td>{{ formatDateString(props.item.createdAt, 'MM/DD/YYYY') }}</td>
                <td v-html="getDocumentStatus(props.item)"></td>
                <!-- <td>{{ formatDateString(props.item.submitted_date, 'MM/DD/YYYY') }}</td> -->
                <td align="right" class="flex-row">
                    <v-btn icon class="ma-0" title="History" @click.stop="getHistory(props.item)">
                        <v-icon size="22" color="grey darken-2">history</v-icon>
                    </v-btn>
                    <v-btn icon class="ma-0" title="View" :to="{ path: `/request/agency/profileDocs/${props.item.id}` }">
                        <v-icon size="22" color="grey darken-2">visibility</v-icon>
                    </v-btn>
                    <v-btn :disabled="getDocumentStatusText(props.item) !== 'Completed'" icon class="ma-0" title="Download ZIP" v-if="props.item.zip" target="_blank" :href="props.item.zip" @click="updateProfileDocument(props.item, 'downloadZIP', props.index)">
                      <v-icon size="22" color="grey darken-2">download</v-icon>
                    </v-btn>
                    <v-btn icon class="ma-0" v-if="props.item.pdf && props.item.pdf.review_history && props.item.pdf.review_history.length" title="PDF History" @click.stop="showPDFHistory(props.item)">
                      <v-icon size="22" color="grey darken-2">work_history</v-icon>
                    </v-btn>
                    <upload-btn ref="uploadButton" :disabled="props.item.pdf && props.item.pdf.review_history && props.item.pdf.review_history.length && props.item.pdf.review_history[props.item.pdf.review_history.length - 1].status !== 'Need Attention'" :class="{ 'disabled': props.item.pdf && props.item.pdf.review_history && props.item.pdf.review_history.length && props.item.pdf.review_history[props.item.pdf.review_history.length - 1].status !== 'Need Attention' }" class="pa-1" v-if="getDocumentStatusText(props.item) === 'Completed'" icon @file-update="uploadPDF($event, props.item, props.index)" color="white" noTitleUpdate labelClass="ma-0 pa-0">
                      <template slot="icon">
                          <v-icon size="22" class="grey--text text--darken-2" title="Upload Completed PDF">cloud_upload</v-icon>
                      </template>
                    </upload-btn>
                </td>
            </tr>
        </template>
        <template v-slot:expand="props">
            <v-card flat class="my-2" v-if="docSubmitItems(props.item).length">
                <v-card-text>
                    <v-data-table
                        :headers="subHeaders"
                        :items="docSubmitItems(props.item)"
                        class="pf-data-table"
                        :pagination.sync="innerPagination"
                    >
                        <template v-slot:items="props">
                            <tr>
                                <td>{{ props.item.chapter }}</td>
                                <td>{{ props.item.type }}</td>
                                <td>{{ formatDateString(props.item.date, 'MM/DD/YYYY') }}</td>
                                <td align="right">
                                  <v-btn icon class="ma-0" @click="viewChapter(props.item.docId, props.item.chapterId, props.item.type)" title="Click to view">
                                    <v-icon size="22" color="grey darken-2">visibility</v-icon>
                                  </v-btn>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </template>
    </v-data-table>
    <template>
      <div class="text-xs-center">
        <v-dialog
          v-model="isHistoryActive"
          width="70%"
        >
          <v-card>
            <v-card-title
              class="pf-bg-teal pf-pos-relative headline white--text"
            >
              History &nbsp; <small>-&nbsp; {{ (historyUsername ? historyUsername : 'Unknown') }}</small>
              <v-btn class="pf-icon-top-right" icon dark @click="isHistoryActive = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-layout>
                <v-flex class="pr-2 pl-2">
                  <v-text-field
                    v-model="historySearch"
                    append-icon="search"
                    label="Search here"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-data-table
                :headers="historyHeaders"
                :items="historyList"
                :search="historySearch"
                no-data-text="No histories found"
                :pagination.sync="historyPagination" 
                class="pf-data-table"
                :expand="expandHistoryTable"
              >
                <template v-slot:items="props">
                  <tr @click="props.expanded = !props.expanded" class="cursor-pointer" title="Click to expand" v-if="props.item && props.item.updatedBy">
                    <td>{{ props.index + 1 }}</td>
                    <td>{{ props.item.action ? props.item.action : 'N/A' }}</td>
                    <td>{{ props.item.updatedBy.human.name }}</td>
                    <td>{{ formatDateString(props.item.createdAt, 'MM/DD/YYYY hh:mm') }}</td>
                  </tr>
                </template>
                <template v-slot:expand="props">
                  <v-card flat class="my-2" v-if="historySubmitItems(props.item).length">
                      <v-card-text>
                          <v-data-table
                              :headers="historySubHeaders"
                              :items="historySubmitItems(props.item)"
                              class="pf-data-table"
                              :pagination.sync="innerPagination"
                          >
                              <template v-slot:items="props">
                                  <tr class="cursor-pointer">
                                      <td>{{ props.index + 1 }}</td>
                                      <td>{{ props.item.chapter }}</td>
                                      <td>{{ props.item.type }}</td>
                                      <td>{{ props.item.data }}</td>
                                  </tr>
                              </template>
                          </v-data-table>
                      </v-card-text>
                  </v-card>
              </template>
              </v-data-table>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="white"
                flat
                @click="isHistoryActive = false"
                class="pf-bg-pink"
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="isPDFHistoryActive"
          width="70%"
        >
          <v-card>
            <v-card-title
              class="pf-bg-teal pf-pos-relative headline white--text"
            >
              History &nbsp; <small>-&nbsp; {{ (historyUsername ? historyUsername : 'Unknown') }}</small>
              <v-btn class="pf-icon-top-right" icon dark @click="isPDFHistoryActive = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-data-table
                :headers="PDFHistoryHeaders"
                :items="PDFhistory"
                no-data-text="No records found"
                :pagination.sync="historyPagination" 
                class="pf-data-table"
              >
                <template v-slot:items="props">
                  <tr class="cursor-pointer" title="Click to expand">
                    <td>{{ props.index + 1 }}</td>
                    <td>{{ PDFStatuses[props.item.status] || props.item.status }}</td>
                    <td>{{ formatDateString(props.item.status_date, 'MM/DD/YYYY hh:mm') }}</td>
                    <td>{{ props.item.description || '' }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="white"
                flat
                @click="isPDFHistoryActive = false"
                class="pf-bg-pink"
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>
  </div>
</template>

<script>
/* global session store config */
/* eslint-disable */
import swal from 'sweetalert2';
import { getCollection, getOne, uploadFile, create, formatDate, update } from '../../helpers/helpers';
import { mapGetters } from 'vuex';
import UploadButton from 'vuetify-upload-button';

// This lists the FAQ items to the agency and family
export default {
    name: 'ProfileDocumentList',
    components: {
      'upload-btn': UploadButton
    },
    data: () => ({
      config,
      entity: 'ProfileDocument',
      expandTable: false,
      expandHistoryTable: false,
      headers: [
        { text: 'Family', value: 'account.name', align: 'left' },
        { text: 'Nickname', value: 'account.nickname', align: 'left' },
        { text: 'PPN', value: 'account.ppn', align: 'left' },
        // { text: 'Chapters', value: 'name', align: 'left' },
        { text: 'Submitted', value: 'submitted_date', align: 'left' },
        { text: 'Created', value: 'createdAt', align: 'left' },
        { text: 'Status', value: '', align: 'left' },
        { text: '', sortable: false },
      ],
      pagination: {
        rowsPerPage: config.dom.rowsPerPage,
        sortBy: ''
      },
      innerPagination: {
        rowsPerPage: config.dom.rowsPerPage,
        sortBy: 'date',
        descending: true
      },
      search: '',
      subHeaders: [
        { text: 'Chapter', value: 'chapter', align: 'left' },
        { text: 'Type', value: 'type', align: 'left' },
        { text: 'Submitted Date', value: 'submitted_date', align: 'left' },
        { text: '', sortable: false },
      ],
      historyList: [],
      historyUsername: '',
      isHistoryActive: false,
      historySearch: '',
      historyHeaders: [
        { text: '#', value: 'id', align: 'left' },
        { text: 'Action', value: 'action', align: 'left' },
        { text: 'Updated By', value: 'updatedBy.human.first_name' },
        { text: 'Date & Time', value: 'createdAt' }
      ],
      historySubHeaders: [
        { text: '#', value: '', align: 'left' },
        { text: 'Chapter', value: 'chapter', align: 'left' },
        { text: 'Type', value: 'type' },
        { text: 'Data', value: 'data' }
      ],
      historyPagination: {
        rowsPerPage: config.dom.rowsPerPage,
        sortBy: ''
      },
      isPDFHistoryActive: false,
      PDFhistory: [],
      PDFHistoryHeaders: [
        { text: '#', value: 'id', align: 'left' },
        { text: 'Action', value: 'PDFStatuses[status]', align: 'left' },
        { text: 'Date & Time', value: 'status_date' },
        { text: 'Suggestion', value: 'description' },
      ],
      PDFStatuses: { 'WriterReview': 'PDF uploaded', 'Need Attention': 'Suggestions added', 'ParentReview': 'Approved by writer', 'Approved': 'Approved by family and submitted for the flipbook' },
      statusListAll: ['All', { value: 'AgencyReview', text: 'Agency Review' }, { value: 'AgencySuggestion', text: 'Agency Suggestion' }, 'Approved', 'Need Attention', { value: 'Review', text: 'Writer Review' }],
      filterStatus: 'All',
      localDocumentList: [],
      writersList: [],
      designersList: []
    }),
    beforeRouteEnter (to, from, next) {
        if (!session.isOnline()) {
            next({ path: '/login' });
        } else {
            next();
        }
    },
    computed: {
        ...mapGetters(['Agency']),
        ProfileDocumentList: {
            get () {
                return store.state.ProfileDocumentList;
            },
            set (value) {
                store.commit('setProfileDocumentList', value);
                this.filterByStatus();
            }
        }
    },
    async created () {
        window.getApp.$vuetify.goTo(document.getElementById('pageHeader').offsetTop - 70);
        if (this.Agency.is_super_admin || this.Agency.is_super_writer || !this.Agency.is_writer) {
            this.headers.splice(3, 0, { text: 'Writer', value: 'writer.name', align: 'left' });
            this.headers.splice(4, 0, { text: 'Designer', value: 'designer.name', align: 'left' });
            await this.fetchWritersList();
            await this.fetchDesignersList();
        }
        await this.fetchReviewRequests();
    },
    methods: {
        // @vuese
        // Used to fetch the FAQ list if not already exists
        async fetchReviewRequests () {
          // if (!this.ProfileDocumentList.length) {
          // let where = { writer: { $exists: true } };
          // where.chapters.content.agency = this.Agency.id;
          let where = {
            $or: [
              { 'chapters.content.agency': this.Agency.id },
              { 'chapters.items.agency': this.Agency.id },
              { 'chapters.special_pictures.front_cover.agency': this.Agency.id },
              { 'chapters.special_pictures.back_cover.agency': this.Agency.id },
              { 'chapters.special_pictures.center_spread.agency': this.Agency.id },
              { 'pdf.review_history.agency': this.Agency.id }
            ]
          };

          let populate = [
            {
              path: 'account',
              select: 'name profile_year profile_number nickname default_agency',
              populate: { path: 'human', select: 'user' }
            },
            { path: 'writer', select: 'name' },
            { path: 'designer', select: 'name' }
          ];
          
          let sort = { 'createdAt': -1 };
          let { error, data } = await getCollection(this.entity, true, 0, populate, where, null, null, sort);
          if (error) {
            console.log(error);
          } else if (data.length) {
            this.ProfileDocumentList = data.filter(x => x.account);
          }
          // }
        },
        async fetchWritersList () {
          let where = { is_writer: true };
          let sort = { 'name': -1 };
          let { error, data } = await getCollection('Agency', true, 0, '', where, null, null, sort);
          if (error) {
            console.log(error);
          } else if (data.length) {
            this.writersList = data;
          }
        },
        async fetchDesignersList () {
          let where = { is_designer: true };
          let sort = { 'name': -1 };
          let { error, data } = await getCollection('Agency', true, 0, '', where, null, null, sort);
          if (error) {
            console.log(error);
          } else if (data.length) {
            this.designersList = data;
          }
        },
        formatDateString (date, format) {
            return formatDate(date, format);
        },
        docSubmitItems (doc) {
            let submittedItems = [];
            if (doc) {
                if (doc.chapters && doc.chapters.length) {
                    doc.chapters.forEach(chapter => {
                        if (chapter.content && chapter.content.status === 'Review') {
                            submittedItems.push({
                                chapter: chapter.name,
                                chapterId: chapter._id,
                                docId: doc.id,
                                type: 'Content',
                                date: chapter.content.status_date
                            });
                        }
                        if (chapter.items && chapter.items.length) {
                            let reviewIndex = chapter.items.findIndex(x => x.status === 'Review');
                            if (reviewIndex > -1) {
                                submittedItems.push({
                                    chapter: chapter.name,
                                    chapterId: chapter._id,
                                    docId: doc.id,
                                    type: 'Photos',
                                    date: chapter.items[reviewIndex].submitted_date
                                });
                            }
                        }
                    });
                }
                if (doc.special_pictures) {
                    let coverSubmitted = null;
                    if (doc.special_pictures.front_cover && doc.special_pictures.front_cover.status === 'Review') {
                        coverSubmitted = 'front_cover';
                    }
                    if (doc.special_pictures.center_spread && doc.special_pictures.center_spread.status === 'Review') {
                        coverSubmitted = 'center_spread';
                    }
                    if (doc.special_pictures.back_cover && doc.special_pictures.back_cover.status === 'Review') {
                        coverSubmitted = 'back_cover';
                    }
                    if (coverSubmitted) {
                        submittedItems.push({
                            chapter: '--',
                            chapterId: null,
                            docId: doc.id,
                            type: 'Covers',
                            date: doc.special_pictures[coverSubmitted].status_date
                        });
                    }
                }
            }
            return submittedItems;
        },
        historySubmitItems (doc) {
          doc = doc.document;
          let historyItems = [];
          if (doc) {
            if (doc.chapters && doc.chapters.length) {
              doc.chapters.forEach(chapter => {
                historyItems.push({
                  chapter: chapter.name,
                  type: 'Content',
                  data: chapter.content && chapter.content.revision && chapter.content.revision.length ? `${chapter.content.revision.length} revisions` : 'No content'
                });
                if (chapter.items && chapter.items.length) {
                  historyItems.push({
                    chapter: chapter.name,
                    type: 'Photos',
                    data: `${chapter.items.length} photos`
                  });
                } else {
                  historyItems.push({
                    chapter: chapter.name,
                    type: 'Photos',
                    data: 'No photos'
                  });
                }
              });
            }
            if (doc.special_pictures) {
              let data = 'Not available';
              if (doc.special_pictures.front_cover && doc.special_pictures.front_cover.photo) {
                data = 'Available';
              } else {
                data = 'Not available';
              }
              historyItems.push({
                chapter: '--',
                type: 'Front Cover',
                data: data
              });
              if (doc.special_pictures.back_cover && doc.special_pictures.back_cover.photo) {
                data = 'Available';
              } else {
                data = 'Not available';
              }
              historyItems.push({
                chapter: '--',
                type: 'Back Cover',
                data: data
              });
              if (doc.special_pictures.center_spread && doc.special_pictures.center_spread.photo) {
                data = 'Available';
              } else {
                data = 'Not available';
              }
              historyItems.push({
                chapter: '--',
                type: 'Center Spread',
                data: data
              });
            } else {
              historyItems = [...historyItems, ...[{
                chapter: '--',
                type: 'Front Cover',
                data: 'Not available'
              }, {
                chapter: '--',
                type: 'Back Cover',
                data: 'Not available'
              }, {
                chapter: '--',
                type: 'Center Spread',
                data: 'Not available'
              }]];
            }
          }
          return historyItems;
        },

        viewChapter (docId, chapterId, type) {
            if (docId && type) {
                this.$router.push({ path: `/request/agency/profileDocs/${docId}`, query: { chapterId: chapterId, area: type }});
            }
        },

        async uploadPDF (files, doc, index) {

          if (!files) {
            return;
          }

          if (files.type !== 'application/pdf') {
            swal.fire({
              title: `<strong>Upload Error</strong>`,
              type: 'error',
              html: 'Please choose a PDF file',
              showCloseButton: true,
              showCancelButton: false,
              focusConfirm: false,
              confirmButtonText: 'Close',
            });
            return;
          } else if (files.size > this.config.uploadFileSize) {
            swal.fire({
              title: `<strong>Upload Error</strong>`,
              type: 'error',
              html: 'Maximum file upload size is ' + (this.config.uploadFileSize / 1024 / 1024) + ' MB',
              showCloseButton: true,
              showCancelButton: false,
              focusConfirm: false,
              confirmButtonText: 'Close',
            });
            return;
          }
          ///
          
          if (files) {
            if (files.name.lastIndexOf('.') <= 0) {
              return;
            }
            
            window.getApp.$emit('AppProgress', true);
            const fr = new FileReader();
            fr.readAsDataURL(files);
            fr.addEventListener('load', async () => {

              window.getApp.$emit('BGProgress', false);

              let postUrl = 'PdfTemplate';
              let extraParams = {
                name: files.name,
                account: doc.account.id,
                directory: '',
                is_active: false,
                request_from: 'ProfileDocument',
                agency: doc.account.default_agency
              };
              let response = await uploadFile(postUrl, files, 'POST', extraParams);
              if (!response.$data) {
                window.getApp.$emit('AppProgress', false);
                console.log('error', response.$error);
                this.snackbar = {
                  show: true,
                  color: 'red',
                  text: response.$error
                };
              } else {
                // Create the timeline
                let timelineData = {
                  title: 'Profile PDF Uploaded',
                  text: `The writer uploaded a profile PDF`
                };
                timelineData.account = doc.account.id;

                let { error, data, status } = await create('Timeline', timelineData);
                if (error) {
                  console.log('error', error);
                  this.snackbar = {
                    show: true,
                    color: 'orange',
                    text: 'Failed to create the timeline'
                  };
                }

                /* Update the ProfileDocument with the PDF status */
                if (response.$data && response.$data.id) {

                  if (!doc.pdf) {
                    doc.pdf = {};
                  }
                  doc.pdf.template = response.$data.id;
                  if (!doc.pdf.review_history) {
                    doc.pdf.review_history = [];
                  }
                  doc.pdf.review_history.push({
                    status: 'WriterReview',
                    status_date: (new Date()).toISOString()
                  });
                  
                  /* Update the state */
                  this.localDocumentList[index] = doc;
                  let origIndex = this.ProfileDocumentList.findIndex(x => x._id.toString() === doc._id.toString());
                  if (origIndex > -1) {
                    this.ProfileDocumentList[origIndex] = doc;
                  }

                  await this.updateProfileDocument(doc, 'uploadPDF', index);

                  /* Clear the selection */
                  this.$refs.uploadButton.clear();

                  /* Filter the data */
                  this.filterByStatus();
                }
                
                swal.fire({
                  type: 'success',
                  title: 'File uploaded successfully',
                  showConfirmButton: false,
                  timer: 2500,
                  onClose: () => {
                    window.getApp.$emit('AppProgress', false);
                  }
                });

              }
              window.getApp.$emit('BGProgress', true);
            });
          }

        },

        async updateProfileDocument(document, requestFrom = "manual", index = -1) {

          let entity = "ProfileDocument";

          if (requestFrom && requestFrom === 'downloadZIP') {
            if (!document.zip_downloaded) {
              document.zip_downloaded = (new Date()).toISOString();
            } else {
              return;
            }
          }
          let updateData = JSON.parse(JSON.stringify(document));
          updateData = await this.formatProfileDocument(updateData);

          if (requestFrom && requestFrom === 'uploadPDF') {
            updateData.request_from = requestFrom;
          }

          let { error, data } = await update(entity, updateData, updateData.id);
          
          if (data.pdf && data.pdf.review_conversation && this.ProfileDocumentList[index] && this.ProfileDocumentList[index].pdf && !this.ProfileDocumentList[index].pdf.review_conversation) {
            this.ProfileDocumentList[index].pdf.review_conversation = data.pdf.review_conversation;
          }
          if (data.pdf && data.pdf.approval_conversation && this.ProfileDocumentList[index] && this.ProfileDocumentList[index].pdf && !this.ProfileDocumentList[index].pdf.approval_conversation) {
            this.ProfileDocumentList[index].pdf.approval_conversation = data.pdf.approval_conversation;
          }
          return { error, data };
        },
        
        async formatProfileDocument(data) {
          if (data.account && data.account.id) {
            data.account = data.account.id;
          }
          if (data.writer && data.writer.id) {
            data.writer = data.writer.id;
          }
          if (data.pdf && data.pdf.template && data.pdf.template.id) {
            data.pdf.template = data.pdf.template.id;
          }
          return data;
        },

        filterByStatus () {
          this.localDocumentList = this.ProfileDocumentList.filter(doc => this.filterStatus === 'All' || (doc.pdf && doc.pdf.review_history && doc.pdf.review_history.length && doc.pdf.review_history[doc.pdf.review_history.length - 1].status === this.filterStatus));
        },
        
        getDocumentStatus(doc) {
            let statuses = [];
            if (doc) {
                /* Consider the PDF statuses prior */
                if (doc.submitted) {
                  if (doc.pdf && doc.pdf.review_history && doc.pdf.review_history.length) {
                    let status = 'Pending';
                    let statusObj = doc.pdf.review_history[doc.pdf.review_history.length - 1];
                    switch (statusObj.status) {
                      case 'WriterReview':
                        status = `<span class="pf-text-warning">PDF Under Writer Review</span>`;
                        break;
                      case 'ParentReview':
                        status = `<span class="pf-text-warning">PDF Under Parent Review</span>`;
                        break;
                      case 'AgencyReview':
                        status = `<span class="pf-text-warning">PDF Under Agency Review</span>`;
                        break;
                      case 'Approved':
                        status = `<span class="pf-text-green">PDF Approved</span>`;
                        break;
                      case 'Need Attention':
                        status = `<span class="pf-text-red">PDF Suggestion</span><p class="font-italic pf-font-12">${doc.pdf && doc.pdf.review_history && doc.pdf.review_history.length ? doc.pdf.review_history[doc.pdf.review_history.length - 1].description : 'No suggestions found'}</p>`;
                        break;
                      case 'AgencySuggestion':
                        status = `<span class="pf-text-red">PDF Suggestion by Agency</span><p class="font-italic pf-font-12">${doc.pdf && doc.pdf.review_history && doc.pdf.review_history.length ? doc.pdf.review_history[doc.pdf.review_history.length - 1].description : 'No suggestions found'}</p>`;
                        break;
                    }
                    return status;
                  }
                }

                if (!doc.chapters || !doc.chapters.length) {
                    statuses.push("Pending");
                }
                doc.chapters.forEach(chapter => {
                    if (chapter.content && chapter.content.status) {
                        statuses.push(chapter.content.status);
                    } else {
                        statuses.push("Pending");
                    }
                    if (chapter.items && chapter.items.length) {
                        chapter.items.forEach(photo => {
                            if (photo && photo.status) {
                                statuses.push(photo.status);
                            }
                        });
                    } else {
                        statuses.push("Pending");
                    }
                });

                if (doc.special_pictures && Object.keys(doc.special_pictures).length) {
                    let special = doc.special_pictures;
                    if (special.front_cover && special.front_cover.status) {
                        statuses.push(special.front_cover.status);
                    } else {
                        statuses.push('Pending');
                    }
                    if (special.back_cover && special.back_cover.status) {
                        statuses.push(special.back_cover.status);
                    } else {
                        statuses.push('Pending');
                    }
                    if (special.center_spread && special.center_spread.status) {
                        statuses.push(special.center_spread.status);
                    } else {
                        statuses.push('Pending');
                    }
                } else {
                    statuses.push("Pending");
                }

                if (statuses.length) {
                    if (statuses.indexOf("Review") > -1) {
                        return `<span class="pf-text-red">Open for Writer</span>`;
                    } else if (statuses.indexOf("AgencyReview") > -1) {
                        return `<span class="pf-text-red">Open</span>`;
                    } else if (statuses.indexOf("WriterReview") > -1) {
                        return `<span class="pf-text-red">Open for Writer</span>`;
                    } else if (statuses.indexOf("Pending") > -1) {
                        return `<span class="pf-text-teal">--</span>`;
                    } else if (statuses.indexOf("Saved") > -1) {
                        return `<span class="pf-text-pink">Saved</span>`;
                    } else if (statuses.indexOf("Suggestion") > -1) {
                        return `<span class="pf-text-warning">Suggestion</span>`;
                    } else if (statuses.indexOf("AgencySuggestion") > -1) {
                        return `<span class="pf-text-warning">Agency Suggestion</span>`;
                    } else if (statuses.indexOf("Replace") > -1) {
                        return `<span class="pf-text-warning">Need Attention</span>`;
                    } else if (statuses.filter(x => x === "Approved").length === statuses.length) {
                        return `<span class="pf-text-green">Completed</span>`;
                    } else {
                        return `<span class="pf-text-teal">--</span>`;
                    }
                }
                
            } else {
                return `<span class="pf-text-teal">--</span>`;
            }
        },
        getDocumentStatusText(doc) {
          let statuses = [];
          if (doc) {
              if (!doc.chapters || !doc.chapters.length) {
                  statuses.push("Pending");
              }
              doc.chapters.forEach(chapter => {
                  if (chapter.content && chapter.content.status) {
                      statuses.push(chapter.content.status);
                  } else {
                      statuses.push("Pending");
                  }
                  if (chapter.items && chapter.items.length) {
                      chapter.items.forEach(photo => {
                          if (photo && photo.status) {
                              statuses.push(photo.status);
                          }
                      });
                  } else {
                      statuses.push("Pending");
                  }
              });

              if (doc.special_pictures && Object.keys(doc.special_pictures).length) {
                  let special = doc.special_pictures;
                  if (special.front_cover && special.front_cover.status) {
                      statuses.push(special.front_cover.status);
                  } else {
                      statuses.push('Pending');
                  }
                  if (special.back_cover && special.back_cover.status) {
                      statuses.push(special.back_cover.status);
                  } else {
                      statuses.push('Pending');
                  }
                  if (special.center_spread && special.center_spread.status) {
                      statuses.push(special.center_spread.status);
                  } else {
                      statuses.push('Pending');
                  }
              } else {
                  statuses.push("Pending");
              }

              if (statuses.length) {
                  if (statuses.indexOf("Review") > -1) {
                      return `Open for Writer`;
                  } else if (statuses.indexOf("WriterReview") > -1) {
                      return `Open for Writer Admin`;
                  } else if (statuses.indexOf("AgencyReview") > -1) {
                      return `Open`;
                  } else if (statuses.indexOf("Pending") > -1) {
                      return `--`;
                  } else if (statuses.indexOf("Saved") > -1) {
                      return `Saved`;
                  } else if (statuses.indexOf("Suggestion") > -1) {
                      return `Suggestion`;
                  } else if (statuses.indexOf("AgencySuggestion") > -1) {
                      return `AgencySuggestion`;
                  } else if (statuses.indexOf("Replace") > -1) {
                      return `Need Attention`;
                  } else if (statuses.filter(x => x === "Approved").length === statuses.length) {
                      return `Completed`;
                  } else {
                      return `--`;
                  }
              }
              
          } else {
              return `--`;
          }
        },
        // @vuese
        // Used to login to the family dashboard by admin
        // @arg The family object to which admin wants to login
        async logonFamily (family) {
          let sessionData;
          let { error, data } = await getOne('User', family.human[0].user);
          if (error) {
            console.log('error', error);
            this.snackbar = {
            show: true,
            color: 'red',
            text: 'Something went wrong, please try again.'
            };
          } else {
            delete data.access;
            sessionData = { ...session.getSession() };
            sessionData.adminUser = session.getSession().user;
            sessionData.user = data;
            session.setSession(sessionData, false);
            location.reload();
          }
        },
        async getHistory (doc) {
          // let humanIds = Array.from(doc.human, x => x.id);
          let sort = { 'createdAt': -1 };
          let where = { entity: 'ProfileDocument', document_id: doc.id, updatedBy: { $exists: true }};
          let populate = { path: 'updatedBy', select: 'entity updatedBy createdAt', populate: { path: 'human', select: 'first_name last_name' }};
          
          let { error, data } = await getCollection('History', true, 10, populate, where, null, null, sort);
          if (error) {
            console.log('error', error);
            this.snackbar = {
              show: true,
              color: 'red',
              text: 'Something went wrong, please try again.'
            };
          } else {
            this.historyList = data;
            this.isHistoryActive = true;
            this.historyUsername = doc.account.name;
          }
        },
        async showPDFHistory (doc) {
          if (doc && doc.pdf && doc.pdf.review_history && doc.pdf.review_history.length) {
            this.PDFhistory = doc.pdf.review_history;
            this.isPDFHistoryActive = true;
            this.historyUsername = doc.account.name;
          }
        },
    }
};
</script>



// WEBPACK FOOTER //
// src/pages/ProfileDocuments/agency_list.vue